(function ($, Drupal, once) {
  "use strict";

  /**
   * Simple colorbox quiz initialization fix.
   * Handles Safari issues and AJAX content changes.
   */

  Drupal.behaviors.colorbox_quiz_fix = {
    
    initializeColorbox: function (context) {
      once("do-colorbox", ".modal-quiz-link", context).forEach(function (el) {
        if (typeof $.colorbox === "function") {
          const $link = $(el);
          const targetSelector = $link.attr('data-colorbox-inline');
          
          if (targetSelector && $(targetSelector).length) {
            // Ensure target content is accessible but hidden
            $(targetSelector).css('visibility', 'visible');
            
            $link.colorbox({
              inline: true,
              href: targetSelector,
              onOpen: function() {
                // Force content to show but hide it initially for animation
                $(targetSelector).show().css('opacity', 0);
              },
              onComplete: function() {
                // Animate content in from opacity 0 to 100%
                $(targetSelector).animate({
                  opacity: 1
                }, 1100);
              },
              onClosed: function() {
                // Hide content again when closed
                $(targetSelector).hide();
              }
            });
          }
        }
      });
    },

    attach: function (context, settings) {
      const self = this;

      $(document).ready(function () {
        // Initialize with slight delay for Safari compatibility
        setTimeout(() => self.initializeColorbox(context), 500);
        
        // Reinitialize after AJAX changes
        $(document).ajaxComplete(function () {
          setTimeout(() => self.initializeColorbox(document), 300);
        });
      });
    },

    detach: function (context, settings, trigger) {
      if (trigger === "unload") {
        once.remove("do-colorbox", ".modal-quiz-link", context);
      }
    }
  };

})(jQuery, Drupal, once);